import React from 'react'

const SvgLogo = props => (
  <svg width="1em" height="1em" viewBox="0 0 18 14" fill="none" {...props}>
    <path
      d="M17.1 0H.9C.4 0 0 .4 0 .9v12.2c0 .5.4.9.9.9h16.2c.5 0 .9-.4.9-.9V.9c0-.5-.4-.9-.9-.9z"
      fill="#4F5B62"
    />
    <path
      d="M9 7.8c-.1 0-.2 0-.3-.1L2 3.6l.5-.9 6.5 4 6.4-3.9.6.8-6.7 4.1c-.1.1-.2.1-.3.1z"
      fill="#fff"
    />
  </svg>
)

export default SvgLogo
